import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

// Lazy load all page components
const Home = lazy(() => import("./Pages/Home"));
const Intro = lazy(() => import("./Pages/Intro"));
const Water = lazy(() => import("./Pages/Water"));
const Forest = lazy(() => import("./Pages/Forest"));
const Sand = lazy(() => import("./Pages/Sand"));
const Cloud = lazy(() => import("./Pages/Cloud"));
const Snow = lazy(() => import("./Pages/Snow"));
const End = lazy(() => import("./Pages/End"));
const DetailPage = lazy(() => import("./Pages/DetailPage"));

// Lazy load data
const getProjectData = lazy(() => import("./Pages/data").then(module => ({ default: module.obj })));

// Loading component for better UX
const LoadingSpinner = () => (
    <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '16px',
        color: '#2a2a2a'
    }}>
        Loading...
    </div>
);

// Detail page wrapper for lazy data loading
const DetailPageWrapper = ({ projectKey }) => {
    const [projectData, setProjectData] = React.useState(null);
    
    React.useEffect(() => {
        import("./Pages/data").then(module => {
            setProjectData(module.obj[projectKey]);
        });
    }, [projectKey]);
    
    if (!projectData) return <LoadingSpinner />;
    
    return (
        <Suspense fallback={<LoadingSpinner />}>
            <DetailPage {...projectData} />
        </Suspense>
    );
};

function App() {
    return(
        <Suspense fallback={<LoadingSpinner />}>
            <Routes>
                <Route path="/" element={<Home />}>
                    <Route path="/" element={<Intro />} />
                    <Route path="water" element={<Water />} />
                    <Route path="forest" element={<Forest />} />
                    <Route path="sand" element={<Sand />} />
                    <Route path="cloud" element={<Cloud />} />
                    <Route path="snow" element={<Snow />} />
                    <Route path="end" element={<End />} />
                    <Route path="snow/ux1919redesign" element={<DetailPageWrapper projectKey="ux1919redesign" />} />
                    <Route path="cloud/timewith99" element={<DetailPageWrapper projectKey="timeWith99" />} />
                    <Route path="cloud/easyboard" element={<DetailPageWrapper projectKey="easyBoard" />} />
                    <Route path="sand/arPipeDream" element={<DetailPageWrapper projectKey="arPipeDream" />} />
                    <Route path="sand/lekima" element={<DetailPageWrapper projectKey="lekima" />} />
                    <Route path="forest/illustration" element={<DetailPageWrapper projectKey="illustration" />} />
                    <Route path="/water/fakeArt" element={<DetailPageWrapper projectKey="fakeArt" />} />
                </Route>
            </Routes>
        </Suspense>
    );
}

export default App;